import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UtilisateurService } from '../../services/utilisateur.service';
import { Utilisateur } from '../../interfaces/utilisateur.interface';

export const utilisateursResolver: ResolveFn<Utilisateur[]> = () => {
  return inject(UtilisateurService).getUtilisateurs();
};
